import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    defaultNS: 'app',
    supportedLngs: ['en', 'es', 'fr', 'de', 'it', 'pt', 'ru', 'ja', 'ar', 'hi', 'ko', 'tr'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      // Vite serves files in /public as static assets
      loadPath: '/locales/app/{{lng}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
